import { render, staticRenderFns } from "./AddClientReward.vue?vue&type=template&id=2fe3d5c8&"
import script from "./AddClientReward.vue?vue&type=script&lang=js&"
export * from "./AddClientReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports